<lui-dialog-container>
  <lui-dialog-content>
    <div
      class="d-flex flex-column justify-content-center align-items-center gap-2 text-center"
    >
      <p>
        {{ warningText }}
      </p>
      <lui-circular-progress
        mode="indeterminate"
        color="grayMedium"
        [diameter]="64"
      ></lui-circular-progress>
    </div>
  </lui-dialog-content>
</lui-dialog-container>
